import { Tooltip } from "@mui/material";
import { InfoOutlined as InfoOutlinedIcon } from "@mui/icons-material";

const ReportDateHeader = () => {
  return (
    <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
      Report Date (MT)
      <Tooltip
        title="All report dates are displayed in Mountain Time (MT)"
        arrow
      >
        <InfoOutlinedIcon
          fontSize="small"
          onClick={(e) => e.stopPropagation()}
          style={{ cursor: "pointer", fontSize: 16 }}
        />
      </Tooltip>
    </span>
  );
};

export default ReportDateHeader;
